export const Messages = {
  Header: {
    Title: 'Lake County Accountability Tracking',
    Buttons: {
      LogOut: 'Log Out',
    },
  },
  DevoteeContainer: {
    Buttons: {
      AddDevotee: 'Add Devotee',
    },
  },
  DevotionalGroupContainer: {
    Buttons: {
      AddDevotionalGroup: 'Add Devotional Group',
    },
  },
  Agreements: {
    No: 'No',
    Agreement: 'No (w/ Agreement)',
    Yes: 'Yes',
  }
};
